import React from 'react';

const Main: React.FunctionComponent<{}> = props =>
    <div className="main mx-0">{props.children}</div>
    
export default Main;